import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-boost';
import fetch from 'isomorphic-fetch';
import base64url from 'base64url';

const customFetch = (uri, options) => {
  try {
    const inflowkit_customer_id = `${typeof window !== 'undefined' &&
      window.localStorage.getItem('in_cid')}`;
    const inflowkit_customer_email = `${typeof window !== 'undefined' &&
      localStorage.getItem('in_email')}`;

    const inflowkit_access_token = process.env.TOKEN;

    const token = base64url.encode(
      `${inflowkit_customer_id},${inflowkit_customer_email},${inflowkit_access_token}`
    );
    return fetch(`${uri}?token=${token}`, options);
  } catch (error) {
    console.log(error);
  }
};

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  uri: `${process.env.GATSBY_API_URL}`,
  request: async operation => {
    operation.setContext({
      fetchOptions: {
        credentials: 'include',
      },
    });
  },
  fetch: customFetch,
  onError: error => {},
});